import React, { useEffect, useContext, useState } from "react";
import {
  Box,
  Button,
  Select,
  FormControl,
  Grid,
  MenuItem,
  InputLabel,
  OutlinedInput,
  Typography,
  Tooltip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import {
  FEEDBACK_TYPE_BUGS,
  IProductParams,
  FEEDBACK_TYPE_FEATURE_REQ,
  TRACKING_SYSTEM_SELF,
  TRACKING_SYSTEM_JIRA,
  TRACKING_SYSTEM_ZENDESK,
  FEEDBACK_TYPE_FEEDBACK,
  INVOKE_TYPE_MANUAL,
  RATING_ICON_TYPE_STAR,
  PLATFORM_TYPE_BROWSER,
  POS_RIGHT_MIDDLE,
  FEEDBACK_FLOW_STATIC,
  IFeedbackAgentSettings,
  IProductInfo,
  STATUS_PRODUCT_ACTIVE,
  webTechs,
  TYPE_NONE,
  brandingIF,
  ITrackingSystem,
} from "../../model";
import { enableChatbot, enableJira } from "../../utils/config";
import { appLogger, Http } from "../../utils";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import HelpIcon from "@mui/icons-material/Help";

import { useLocation, useNavigate, useParams } from "react-router-dom";

import { cloneDeep } from "lodash";

import JiraSetttingsHeader from "./JiraSetttingsHeader";
import {
  enableFeedback,
  enableBugReport,
  enableFeatureRequest,
} from "../../utils/config";
import { HideOrShowText } from "../common/hideOrShowText";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:before": {
    display: "none",
  },
}));

const TrackingSystemSettings = (props: any) => {
  const { productId, versionId } = useParams();
  const location: any = useLocation();
  const navigate = useNavigate();

  appLogger.info({
    infoObj: {
      method: "trackingSysSettings",
      component: "add-product",
      fileName: "trackingSysSettings.tsx",
      props: props,
    },
  });
  const {
    setScroll,
    errMsg,
    setErrMsg,
    sethandleClick,
    productParams,
    setProductParams,
  } = props;

  // const [productParams, setProductParams] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState("");
  const [isSevCheck, setIsSevCheck] = useState(false);
  const [projectList, setProjectList] = useState<any>({});
  const [zendeskTagList, setZendeskTagList] = useState<any>({});
  const zendeskTicketTypeList = ["incident", "problem", "question", "task"];
  const zendeskPriorityList = ["low", "normal", "high", "urgent"];
  const [issueList, setIssueList] = useState<any>({});
  const [sevList, setSevList] = useState<any>({});
  const [isBugToolConnected, setIsBugToolConnected] = useState(false);
  const [isFeedbackToolConnected, setIsFeedbackToolConnected] = useState(false);
  const [isFeatureToolConnected, setIsFeatureToolConnected] = useState(false);
  const {
    userInfo,
    setBasicDetailAccordianContext,
    setGenSettingsAccordianContext,
    setFbSettingsAccordianContext,
    setBugSettingsAccordianContext,
    setFreqSettingsAccordianContext,
    EmailSettingsAccordianContext,
    setEmailSettingsAccordianContext,
    setExttrackingSettingsAccordianContext,
    ExttrackingSettingsAccordianContext,
    setWidgAppSettingsAccordianContext,
    setWidgIntgSettingsAccordianContext,
    enabledFeatures,
    orgId,
  } = useContext(UserContext) as UserLoginInfo;
  const [fieldErrMsg, setFieldErrMsg] = useState<any>({});

  const defaultJiraSettings: ITrackingSystem = {
    feedbackTypes: [
      FEEDBACK_TYPE_FEEDBACK,
      FEEDBACK_TYPE_BUGS,
      FEEDBACK_TYPE_FEATURE_REQ,
    ],
    configs: {
      [FEEDBACK_TYPE_BUGS]: {
        auth: {},
        type: "JIRA",
        subject: "CuVo Chatbot ticket",
      },
      [FEEDBACK_TYPE_FEATURE_REQ]: {
        auth: {},
        type: "JIRA",
        subject: "CuVo Chatbot ticket",
      },
      [FEEDBACK_TYPE_FEEDBACK]: {
        auth: {},
        type: "JIRA",
        subject: "CuVo Chatbot ticket",
      },
    },
  };

  useEffect(() => {
    // if (
    //   productParams &&
    //   productParams.products &&
    //   productParams.products[0] &&
    //   productParams.products[0].trackingSystem
    // ) {
    //   if (
    //     productParams.products[0].trackingSystem &&
    //     productParams.products[0].trackingSystem.feedbackTypes &&
    //     productParams.products[0].trackingSystem.feedbackTypes.includes(
    //       FEEDBACK_TYPE_BUGS
    //     )
    //   ) {
    //     if (productParams.products[0].trackingSystem.configs[FEEDBACK_TYPE_BUGS].type  == "SELF") {
    //       const temp = {...productParams};
    //       temp.products[0].trackingSystem.configs[FEEDBACK_TYPE_BUGS].type = "JIRA";
    //       setProductParams(temp);
    //     }
    //     if (
    //       productParams.products[0].trackingSystem &&
    //       productParams.products[0].trackingSystem.configs &&
    //       productParams.products[0].trackingSystem.configs[
    //         FEEDBACK_TYPE_BUGS
    //       ] &&
    //       productParams.products[0].trackingSystem.configs[FEEDBACK_TYPE_BUGS]
    //         .isToolConnected
    //     ) {
    //       setIsBugToolConnected(true);
    //       appLogger.info(
    //         {
    //           infoObj: {
    //             method: "useEffect",
    //             component: "add-product",
    //             fileName: "trackingSysSettings.tsx",
    //             setIsBugToolConnected: true,
    //           },
    //         },
    //         "Tool Connected"
    //       );
    //     } else if (
    //       productParams.products[0].trackingSystem &&
    //       productParams.products[0].trackingSystem.configs &&
    //       productParams.products[0].trackingSystem.configs[FEEDBACK_TYPE_BUGS]
    //     ) {
    //       setIsBugToolConnected(false);
    //       appLogger.info(
    //         {
    //           infoObj: {
    //             method: "useEffect",
    //             component: "add-product",
    //             fileName: "trackingSysSettings.tsx",
    //             setIsBugToolConnected: false,
    //           },
    //         },
    //         "Tool not Connected"
    //       );
    //     }
    //     if (
    //       productParams.products[0].trackingSystem &&
    //       productParams.products[0].trackingSystem.configs &&
    //       productParams.products[0].trackingSystem.configs[
    //         FEEDBACK_TYPE_BUGS
    //       ] &&
    //       productParams.products[0].trackingSystem.configs[FEEDBACK_TYPE_BUGS]
    //         .severity
    //     ) {
    //       setIsSevCheck(true);
    //     } else if (
    //       productParams.products[0].trackingSystem &&
    //       productParams.products[0].trackingSystem.configs &&
    //       productParams.products[0].trackingSystem.configs[FEEDBACK_TYPE_BUGS]
    //     ) {
    //       setIsSevCheck(false);
    //     }
    //   }
    //   if (
    //     productParams.products[0].trackingSystem &&
    //     productParams.products[0].trackingSystem.feedbackTypes &&
    //     productParams.products[0].trackingSystem.feedbackTypes.includes(
    //       FEEDBACK_TYPE_FEATURE_REQ
    //     )
    //   ) {
    //     if (productParams.products[0].trackingSystem.configs[FEEDBACK_TYPE_FEATURE_REQ].type == "SELF") {
    //       const temp = {...productParams};
    //       temp.products[0].trackingSystem.configs[FEEDBACK_TYPE_FEATURE_REQ].type = "JIRA";
    //       setProductParams(temp);
    //     }
    //     if (
    //       productParams.products[0].trackingSystem &&
    //       productParams.products[0].trackingSystem.configs &&
    //       productParams.products[0].trackingSystem.configs[
    //         FEEDBACK_TYPE_FEATURE_REQ
    //       ] &&
    //       productParams.products[0].trackingSystem.configs[
    //         FEEDBACK_TYPE_FEATURE_REQ
    //       ].isToolConnected
    //     ) {
    //       appLogger.info(
    //         {
    //           infoObj: {
    //             method: "useEffect",
    //             component: "add-product",
    //             fileName: "trackingSysSettings.tsx",
    //             setIsFeatureToolConnected: true,
    //           },
    //         },
    //         "Tool Connected"
    //       );
    //       setIsFeatureToolConnected(true);
    //     } else if (
    //       productParams.products[0].trackingSystem &&
    //       productParams.products[0].trackingSystem.configs &&
    //       productParams.products[0].trackingSystem.configs[
    //         FEEDBACK_TYPE_FEATURE_REQ
    //       ]
    //     ) {
    //       appLogger.info(
    //         {
    //           infoObj: {
    //             method: "useEffect",
    //             component: "add-product",
    //             fileName: "trackingSysSettings.tsx",
    //             setIsFeatureToolConnected: false,
    //           },
    //         },
    //         "Tool not Connected"
    //       );
    //       setIsFeatureToolConnected(false);
    //     }
    //   }
    //   if (
    //     productParams.products[0].trackingSystem &&
    //     productParams.products[0].trackingSystem.feedbackTypes &&
    //     productParams.products[0].trackingSystem.feedbackTypes.includes(
    //       FEEDBACK_TYPE_FEEDBACK
    //     )
    //   ) {
    //     if (productParams.products[0].trackingSystem.configs[FEEDBACK_TYPE_FEEDBACK].type == "SELF") {
    //       const temp = {...productParams};
    //       temp.products[0].trackingSystem.configs[FEEDBACK_TYPE_FEEDBACK].type = "JIRA";
    //       setProductParams(temp);
    //     }
    //     if (
    //       productParams.products[0].trackingSystem &&
    //       productParams.products[0].trackingSystem.configs &&
    //       productParams.products[0].trackingSystem.configs.FEEDBACK &&
    //       productParams.products[0].trackingSystem.configs.FEEDBACK
    //         .isToolConnected
    //     ) {
    //       setIsFeedbackToolConnected(true);
    //       appLogger.info(
    //         {
    //           infoObj: {
    //             method: "useEffect",
    //             component: "add-product",
    //             fileName: "trackingSysSettings.tsx",
    //             setIsFeedbackToolConnected: true,
    //           },
    //         },
    //         "Tool Connected"
    //       );
    //     } else if (
    //       productParams.products[0].trackingSystem &&
    //       productParams.products[0].trackingSystem.configs &&
    //       productParams.products[0].trackingSystem.configs.FEEDBACK
    //     ) {
    //       setIsFeedbackToolConnected(false);
    //       appLogger.info(
    //         {
    //           infoObj: {
    //             method: "useEffect",
    //             component: "add-product",
    //             fileName: "trackingSysSettings.tsx",
    //             setIsFeedbackToolConnected: false,
    //           },
    //         },
    //         "Tool not Connected"
    //       );
    //     }
    //   }
    // }
    if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].jiraSettings
    ) {
      if (
        productParams.products[0].jiraSettings &&
        productParams.products[0].jiraSettings.feedbackTypes &&
        productParams.products[0].jiraSettings.feedbackTypes.includes(
          FEEDBACK_TYPE_BUGS
        )
      ) {
        if (
          productParams.products[0].jiraSettings.configs[FEEDBACK_TYPE_BUGS]
            .type == "SELF"
        ) {
          const temp = { ...productParams };
          temp.products[0].jiraSettings.configs[FEEDBACK_TYPE_BUGS].type =
            "JIRA";
          setProductParams(temp);
        }
        if (
          productParams.products[0].jiraSettings &&
          productParams.products[0].jiraSettings.configs &&
          productParams.products[0].jiraSettings.configs[FEEDBACK_TYPE_BUGS] &&
          productParams.products[0].jiraSettings.configs[FEEDBACK_TYPE_BUGS]
            .isToolConnected
        ) {
          setIsBugToolConnected(true);
          appLogger.info(
            {
              infoObj: {
                method: "useEffect",
                component: "add-product",
                fileName: "trackingSysSettings.tsx",
                setIsBugToolConnected: true,
              },
            },
            "Tool Connected"
          );
        } else if (
          productParams.products[0].jiraSettings &&
          productParams.products[0].jiraSettings.configs &&
          productParams.products[0].jiraSettings.configs[FEEDBACK_TYPE_BUGS]
        ) {
          setIsBugToolConnected(false);
          appLogger.info(
            {
              infoObj: {
                method: "useEffect",
                component: "add-product",
                fileName: "trackingSysSettings.tsx",
                setIsBugToolConnected: false,
              },
            },
            "Tool not Connected"
          );
        }
        if (
          productParams.products[0].jiraSettings &&
          productParams.products[0].jiraSettings.configs &&
          productParams.products[0].jiraSettings.configs[FEEDBACK_TYPE_BUGS] &&
          productParams.products[0].jiraSettings.configs[FEEDBACK_TYPE_BUGS]
            .severity
        ) {
          setIsSevCheck(true);
        } else if (
          productParams.products[0].jiraSettings &&
          productParams.products[0].jiraSettings.configs &&
          productParams.products[0].jiraSettings.configs[FEEDBACK_TYPE_BUGS]
        ) {
          setIsSevCheck(false);
        }
      }
      if (
        productParams.products[0].jiraSettings &&
        productParams.products[0].jiraSettings.feedbackTypes &&
        productParams.products[0].jiraSettings.feedbackTypes.includes(
          FEEDBACK_TYPE_FEATURE_REQ
        )
      ) {
        if (
          productParams.products[0].jiraSettings.configs[
            FEEDBACK_TYPE_FEATURE_REQ
          ].type == "SELF"
        ) {
          const temp = { ...productParams };
          temp.products[0].jiraSettings.configs[
            FEEDBACK_TYPE_FEATURE_REQ
          ].type = "JIRA";
          setProductParams(temp);
        }
        if (
          productParams.products[0].jiraSettings &&
          productParams.products[0].jiraSettings.configs &&
          productParams.products[0].jiraSettings.configs[
            FEEDBACK_TYPE_FEATURE_REQ
          ] &&
          productParams.products[0].jiraSettings.configs[
            FEEDBACK_TYPE_FEATURE_REQ
          ].isToolConnected
        ) {
          appLogger.info(
            {
              infoObj: {
                method: "useEffect",
                component: "add-product",
                fileName: "trackingSysSettings.tsx",
                setIsFeatureToolConnected: true,
              },
            },
            "Tool Connected"
          );
          setIsFeatureToolConnected(true);
        } else if (
          productParams.products[0].jiraSettings &&
          productParams.products[0].jiraSettings.configs &&
          productParams.products[0].jiraSettings.configs[
            FEEDBACK_TYPE_FEATURE_REQ
          ]
        ) {
          appLogger.info(
            {
              infoObj: {
                method: "useEffect",
                component: "add-product",
                fileName: "trackingSysSettings.tsx",
                setIsFeatureToolConnected: false,
              },
            },
            "Tool not Connected"
          );
          setIsFeatureToolConnected(false);
        }
      }
      if (
        productParams.products[0].jiraSettings &&
        productParams.products[0].jiraSettings.feedbackTypes &&
        productParams.products[0].jiraSettings.feedbackTypes.includes(
          FEEDBACK_TYPE_FEEDBACK
        )
      ) {
        if (
          productParams.products[0].jiraSettings.configs[FEEDBACK_TYPE_FEEDBACK]
            .type == "SELF"
        ) {
          const temp = { ...productParams };
          temp.products[0].jiraSettings.configs[FEEDBACK_TYPE_FEEDBACK].type =
            "JIRA";
          setProductParams(temp);
        }
        if (
          productParams.products[0].jiraSettings &&
          productParams.products[0].jiraSettings.configs &&
          productParams.products[0].jiraSettings.configs.FEEDBACK &&
          productParams.products[0].jiraSettings.configs.FEEDBACK
            .isToolConnected
        ) {
          setIsFeedbackToolConnected(true);
          appLogger.info(
            {
              infoObj: {
                method: "useEffect",
                component: "add-product",
                fileName: "trackingSysSettings.tsx",
                setIsFeedbackToolConnected: true,
              },
            },
            "Tool Connected"
          );
        } else if (
          productParams.products[0].jiraSettings &&
          productParams.products[0].jiraSettings.configs &&
          productParams.products[0].jiraSettings.configs.FEEDBACK
        ) {
          setIsFeedbackToolConnected(false);
          appLogger.info(
            {
              infoObj: {
                method: "useEffect",
                component: "add-product",
                fileName: "trackingSysSettings.tsx",
                setIsFeedbackToolConnected: false,
              },
            },
            "Tool not Connected"
          );
        }
      }
    } else if (productParams && productParams.products[0]) {
      const temp = { ...productParams };
      temp.products[0]["jiraSettings"] = defaultJiraSettings;
      setProductParams(temp);
    }
  }, [productParams]);

  const removeHandleConnection = (type: string) => {
    if (type === FEEDBACK_TYPE_BUGS) {
      setIsBugToolConnected(false);
      if (
        productParams.products[0].jiraSettings &&
        productParams.products[0].jiraSettings.configs &&
        productParams.products[0].jiraSettings.configs[FEEDBACK_TYPE_BUGS] &&
        productParams.products[0].jiraSettings.configs[FEEDBACK_TYPE_BUGS]
          .isToolConnected
      ) {
        productParams.products[0].jiraSettings.configs[
          FEEDBACK_TYPE_BUGS
        ].isToolConnected = false;
      }
    } else if (type === FEEDBACK_TYPE_FEEDBACK) {
      setIsFeedbackToolConnected(false);
      if (
        productParams.products[0].jiraSettings &&
        productParams.products[0].jiraSettings.configs &&
        productParams.products[0].jiraSettings.configs.FEEDBACK &&
        productParams.products[0].jiraSettings.configs.FEEDBACK.isToolConnected
      ) {
        productParams.products[0].jiraSettings.configs.FEEDBACK.isToolConnected =
          false;
      }
    } else {
      setIsFeatureToolConnected(false);
      if (
        productParams.products[0].jiraSettings &&
        productParams.products[0].jiraSettings.configs &&
        productParams.products[0].jiraSettings.configs[
          FEEDBACK_TYPE_FEATURE_REQ
        ] &&
        productParams.products[0].jiraSettings.configs[
          FEEDBACK_TYPE_FEATURE_REQ
        ].isToolConnected
      ) {
        productParams.products[0].jiraSettings.configs[
          FEEDBACK_TYPE_FEATURE_REQ
        ].isToolConnected = false;
      }
    }
  };

  const clearErrMsg = (errMsg: any, type: string) => {
    if (
      errMsg &&
      errMsg[type] &&
      errMsg[type].extProjectTypeErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].jiraSettings &&
      productParams.products[0].jiraSettings.configs &&
      productParams.products[0].jiraSettings.configs[type] &&
      productParams.products[0].jiraSettings.configs[type].url
    ) {
      const msg = { ...errMsg };
      msg[type].extProjectTypeErr = null;
      setErrMsg(msg);
    }
    if (
      errMsg &&
      errMsg[type] &&
      errMsg[type].extIssueTypeErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].jiraSettings &&
      productParams.products[0].jiraSettings.configs &&
      productParams.products[0].jiraSettings.configs[type] &&
      productParams.products[0].jiraSettings.configs[type].auth &&
      productParams.products[0].jiraSettings.configs[type].auth.authUser
    ) {
      const msg = { ...errMsg };
      msg[type].extIssueTypeErr = null;
      setErrMsg(msg);
    }
    if (
      errMsg &&
      errMsg[type] &&
      errMsg[type].extDefaultSevErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].jiraSettings &&
      productParams.products[0].jiraSettings.configs &&
      productParams.products[0].jiraSettings.configs[type] &&
      productParams.products[0].jiraSettings.configs[type].auth &&
      productParams.products[0].jiraSettings.configs[type].auth.authKey
    ) {
      const msg = { ...errMsg };
      msg[type].extDefaultSevErr = null;
      setErrMsg(msg);
    }
  };

  const handleToolConnect = (type: string) => {
    if (
      productParams &&
      productParams.products[0] &&
      productParams.products[0].jiraSettings &&
      productParams.products[0].jiraSettings.configs &&
      productParams.products[0].jiraSettings.configs[type] &&
      productParams.products[0].jiraSettings.configs[type] &&
      productParams.products[0].jiraSettings.configs[type].url
    ) {
      if (
        productParams &&
        productParams.products[0] &&
        productParams.products[0].jiraSettings &&
        productParams.products[0].jiraSettings.configs &&
        productParams.products[0].jiraSettings.configs[type] &&
        productParams.products[0].jiraSettings.configs[type] &&
        productParams.products[0].jiraSettings.configs[type].auth &&
        productParams.products[0].jiraSettings.configs[type].auth.authUser
      ) {
        if (
          productParams &&
          productParams.products[0] &&
          productParams.products[0].jiraSettings &&
          productParams.products[0].jiraSettings.configs &&
          productParams.products[0].jiraSettings.configs[type] &&
          productParams.products[0].jiraSettings.configs[type].type &&
          productParams.products[0].jiraSettings.configs[type].auth &&
          productParams.products[0].jiraSettings.configs[type].auth.authKey
        ) {
          if (type) {
            fetchProjectList(type);
            fetchIssueList(type);
            fetchSevList(type);
          }
        } else {
          props.snackbarShowMessage(
            "You must provide tracking system auth key",
            "error",
            3000
          );
          const updatedValue = {
            [type]: {
              trackingKeyErr: "You must provide tracking system auth Key",
            },
          };
          setFieldErrMsg(() => ({
            ...{},
            ...updatedValue,
          }));
          return false;
        }
      } else {
        props.snackbarShowMessage(
          "You must provide tracking system auth User Email",
          "error",
          3000
        );
        const updatedValue = {
          [type]: {
            trackingUserErr: "You must provide tracking system auth User Email",
          },
        };
        setFieldErrMsg(() => ({
          ...{},
          ...updatedValue,
        }));
        return false;
      }
    } else {
      appLogger.error(
        { errObj: { method: "handleToolConnect" } },
        "url missing"
      );
      props.snackbarShowMessage(
        "You must provide tracking system URL",
        "error",
        3000
      );
      const updatedValue = {
        [type]: {
          trackingUrlErr: "You must provide tracking system URL",
        },
      };
      setFieldErrMsg(() => ({
        ...{},
        ...updatedValue,
      }));
      return false;
    }
  };

  useEffect(() => {
    if (isBugToolConnected) {
      handleToolConnect(FEEDBACK_TYPE_BUGS);
    }
  }, [isBugToolConnected]);

  useEffect(() => {
    if (isFeatureToolConnected) {
      handleToolConnect(FEEDBACK_TYPE_FEATURE_REQ);
    }
  }, [isFeatureToolConnected]);

  useEffect(() => {
    if (isFeedbackToolConnected) {
      handleToolConnect(FEEDBACK_TYPE_FEEDBACK);
    }
  }, [isFeedbackToolConnected]);

  const handleToolConnectStatus = (type: string) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].jiraSettings &&
        temp.products[0].jiraSettings.configs
      ) {
        if (
          temp &&
          temp.products[0] &&
          temp.products[0].jiraSettings &&
          temp.products[0].jiraSettings.configs &&
          temp.products[0].jiraSettings.configs[type]
        ) {
          temp.products[0].jiraSettings.configs[type].isToolConnected = true;
        }
        setProductParams(temp);
      }
    }
  };

  const updateBugSev = (sevList: any) => {
    appLogger.info(
      {
        infoObj: {
          method: "updateBugSev",
          component: "add-product",
          fileName: "trackingSysSettings.tsx",
          severities: sevList,
        },
      },
      "Bug severities updated"
    );
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].feedbackAgentSettings &&
        temp.products[0].feedbackAgentSettings.bugSettings
      ) {
        if (!temp.products[0].feedbackAgentSettings.bugSettings.severities) {
          temp.products[0].feedbackAgentSettings.bugSettings.severities = [];
        }
        if (
          temp &&
          temp.products[0] &&
          temp.products[0].jiraSettings &&
          temp.products[0].jiraSettings.configs &&
          temp.products[0].jiraSettings.configs[FEEDBACK_TYPE_BUGS]
        ) {
          temp.products[0].jiraSettings.configs[FEEDBACK_TYPE_BUGS].severity =
            true;
        }
        temp.products[0].feedbackAgentSettings.bugSettings.severities = [
          ...sevList,
        ];
        setProductParams(temp);
      }
    }
  };

  const fetchProjectList = (type: string) => {
    setIsLoading(type);
    const authData = {
      ...productParams.products[0].jiraSettings.configs[type].auth,
    };
    authData.authUser = authData.authUser.toLowerCase();
    Http.post({
      url: `/api/v2/extTrackingSystem/`,
      state: userInfo,
      body: {
        tool: productParams.products[0].jiraSettings.configs[type].type,
        field: "project",
        url: productParams.products[0].jiraSettings.configs[type].url,
        // config: productParams.products[0].jiraSettings.configs[type].auth,
        config: authData,
      },
    })
      .then((response: any) => {
        setIsLoading("");
        // props.snackbarShowMessage('Fetched Project List', "success", 3000);
        if (response.result && response.result.length > 0) {
          const projects = { ...projectList };
          projects[type] = response.result;
          appLogger.info({
            infoObj: {
              method: "fetchProjectList",
              component: "add-product",
              fileName: "trackingSysSettings.tsx",
              projectListResponse: response.result,
            },
          });
          setProjectList((prev: any) => {
            return { ...prev, ...projects };
          });
        } else {
          const projects = { ...projectList };
          projects[type] = [];
          setProjectList((prev: any) => {
            return { ...projects };
          });
          // props.snackbarShowMessage('Not able to connect to JIRA', "error", 3000);
        }
        handleToolConnectStatus(type);
      })
      .catch((error) => {
        appLogger.error({
          errObj: {
            method: "fetchProjectList",
            component: "add-product",
            fileName: "trackingSysSettings.tsx",
            err: error,
          },
        });
        setIsLoading("");
        props.snackbarShowMessage("Not able to connect to JIRA", "error", 3000);
      });
  };

  const fetchSevList = (type: string) => {
    const authData = {
      ...productParams.products[0].jiraSettings.configs[type].auth,
    };
    authData.authUser = authData.authUser.toLowerCase();
    Http.post({
      url: `/api/v2/extTrackingSystem/`,
      state: userInfo,
      body: {
        tool: productParams.products[0].jiraSettings.configs[type].type,
        field: "severity",
        url: productParams.products[0].jiraSettings.configs[type].url,
        // config: productParams.products[0].jiraSettings.configs[type].auth,
        config: authData,
      },
    })
      .then((response: any) => {
        // props.snackbarShowMessage('Fetched Project List', "success", 3000);
        appLogger.info({
          infoObj: {
            method: "fetchSevList",
            component: "add-product",
            fileName: "trackingSysSettings.tsx",
            severityListResponse: response.result,
          },
        });
        if (type === FEEDBACK_TYPE_BUGS) {
          updateBugSev(response.result);
        }
        const severities = { ...sevList };
        severities[type] = response.result;
        appLogger.info({
          infoObj: {
            method: "fetchProjectList",
            component: "add-product",
            fileName: "trackingSysSettings.tsx",
            projectListResponse: response.result,
          },
        });
        setSevList((prev: any) => {
          return { ...severities, ...prev };
        });
        // setSevList(response.result);
      })
      .catch((error) => {
        appLogger.error({
          errObj: {
            method: "fetchSevList",
            component: "add-product",
            fileName: "trackingSysSettings.tsx",
            err: error,
          },
        });
      });
  };

  const fetchIssueList = (type: string) => {
    const authData = {
      ...productParams.products[0].jiraSettings.configs[type].auth,
    };
    authData.authUser = authData.authUser.toLowerCase();
    Http.post({
      url: `/api/v2/extTrackingSystem/`,
      state: userInfo,
      body: {
        tool: productParams.products[0].jiraSettings.configs[type].type,
        field: "issuetype",
        url: productParams.products[0].jiraSettings.configs[type].url,
        // config: productParams.products[0].jiraSettings.configs[type].auth,
        config: authData,
      },
    })
      .then((response: any) => {
        // props.snackbarShowMessage('Fetched Project List', "success", 3000);
        appLogger.info({
          infoObj: {
            method: "fetchIssueList",
            component: "add-product",
            fileName: "trackingSysSettings.tsx",
            issueTypeResponse: response.result,
          },
        });
        const issues = { ...issueList };
        issues[type] = response.result;
        setIssueList((prev: any) => {
          return { ...issues, ...prev };
        });
      })
      .catch((error) => {
        appLogger.error({
          errObj: {
            method: "fetchIssueLis",
            component: "add-product",
            fileName: "trackingSysSettings.tsx",
            err: error,
          },
        });
      });
  };

  const clearFieldErrMsg = (fieldErrMsg: any, type: string) => {
    if (
      fieldErrMsg &&
      fieldErrMsg[type] &&
      fieldErrMsg[type].trackingUrlErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].jiraSettings &&
      productParams.products[0].jiraSettings.configs &&
      productParams.products[0].jiraSettings.configs[type] &&
      productParams.products[0].jiraSettings.configs[type].url
    ) {
      const msg = { ...fieldErrMsg };
      msg[type].trackingUrlErr = null;
      setFieldErrMsg(msg);
    }
    if (
      fieldErrMsg &&
      fieldErrMsg[type] &&
      fieldErrMsg[type].trackingUserErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].jiraSettings &&
      productParams.products[0].jiraSettings.configs &&
      productParams.products[0].jiraSettings.configs[type] &&
      productParams.products[0].jiraSettings.configs[type].auth &&
      productParams.products[0].jiraSettings.configs[type].auth.authUser
    ) {
      const msg = { ...fieldErrMsg };
      msg[type].trackingUserErr = null;
      setFieldErrMsg(msg);
    }
    if (
      fieldErrMsg &&
      fieldErrMsg[type] &&
      fieldErrMsg[type].trackingKeyErr &&
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].jiraSettings &&
      productParams.products[0].jiraSettings.configs &&
      productParams.products[0].jiraSettings.configs[type] &&
      productParams.products[0].jiraSettings.configs[type].auth &&
      productParams.products[0].jiraSettings.configs[type].auth.authKey
    ) {
      const msg = { ...fieldErrMsg };
      msg[type].trackingKeyErr = null;
      setFieldErrMsg(msg);
    }
  };

  const handleAuthUserDetails = (event: any, type: string) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].jiraSettings &&
        temp.products[0].jiraSettings.configs
      ) {
        const newData = temp.products[0].jiraSettings.configs;
        if (
          temp &&
          temp.products &&
          temp.products[0] &&
          temp.products[0].jiraSettings &&
          temp.products[0].jiraSettings.configs &&
          temp.products[0].jiraSettings.configs[type]
        ) {
          if (temp.products[0].jiraSettings.configs[type].auth) {
            temp.products[0].jiraSettings.configs[type].auth.authUser =
              event.target.value;
          } else {
            temp.products[0].jiraSettings.configs[type].auth = {};
            temp.products[0].jiraSettings.configs[type].auth.authUser =
              event.target.value;
          }
        } else {
          newData[type].auth = {};
          newData[type].auth.authUser = event.target.value;
          temp.products[0].jiraSettings.configs = newData;
        }
        clearFieldErrMsg(fieldErrMsg, type);
        setProductParams(temp);
      }
    }
  };

  const handleAuthKeyDetails = (event: any, type: string) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].jiraSettings &&
        temp.products[0].jiraSettings.configs
      ) {
        const newData = temp.products[0].jiraSettings.configs;
        if (
          temp &&
          temp.products &&
          temp.products[0] &&
          temp.products[0].jiraSettings &&
          temp.products[0].jiraSettings.configs &&
          temp.products[0].jiraSettings.configs[type]
        ) {
          if (temp.products[0].jiraSettings.configs[type].auth) {
            temp.products[0].jiraSettings.configs[type].auth.authKey =
              event.target.value;
          } else {
            temp.products[0].jiraSettings.configs[type].auth = {};
            temp.products[0].jiraSettings.configs[type].auth.authKey =
              event.target.value;
          }
        } else {
          newData[type].auth = {};
          newData[type].auth.authUser = event.target.value;
          temp.products[0].jiraSettings.configs = newData;
        }
        clearFieldErrMsg(fieldErrMsg, type);
        setProductParams(temp);
      }
    }
  };

  const handleFieldChange = (event: any, type: string, field: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].jiraSettings &&
        temp.products[0].jiraSettings.configs
      ) {
        const newMessages = temp.products[0].jiraSettings.configs;
        if (newMessages[type]) {
          newMessages[type][field] = event.target.value;
        }
        temp.products[0].jiraSettings.configs = newMessages;
        clearErrMsg(errMsg, type);
        clearFieldErrMsg(fieldErrMsg, type);
        setProductParams(temp);
      }
    }
  };

  const handleSystemTypeChange = (event: any, type: string) => {
    if (productParams) {
      const temp: IProductParams | undefined = cloneDeep(productParams);
      if (
        temp &&
        temp.products &&
        temp.products[0] &&
        temp.products[0].jiraSettings &&
        temp.products[0].jiraSettings.configs
      ) {
        if (
          event &&
          !temp.products[0].jiraSettings.feedbackTypes.includes(type)
        ) {
          temp.products[0].jiraSettings.feedbackTypes.push(type);
        }
        const newConfigs = temp.products[0].jiraSettings.configs;

        newConfigs[type] = { auth: {}, type: event.target.value };
      } else if (temp && temp.products[0] && temp.products[0].jiraSettings) {
        temp.products[0].jiraSettings = {
          feedbackTypes: [type],
          configs: {},
        };
        temp.products[0].jiraSettings.configs[type] = {
          auth: {},
          type: event.target.value,
        };
      }
      setProductParams(temp);
    }
  };

  const scroll = (e: any) => {
    e.stopPropagation();
    setScroll("extTracker");
    handleAccordianChange(true, "basicDetails", "accordian");
    sethandleClick(2);
  };

  const handleAccordianChange = (value: any, type: any, clickType: any) => {
    appLogger.info({
      infoObj: {
        method: "handleAccordianChange",
        component: "add-product",
        fileName: "trackingSysSettings.tsx",
        accordianChangesData: { value, type },
      },
    });
    setGenSettingsAccordianContext(false);
    setBasicDetailAccordianContext(false);
    setFbSettingsAccordianContext(false);
    setBugSettingsAccordianContext(false);
    setFreqSettingsAccordianContext(false);
    setEmailSettingsAccordianContext(false);
    setExttrackingSettingsAccordianContext(value);
    setWidgAppSettingsAccordianContext(false);
    setWidgIntgSettingsAccordianContext(false);
    if (clickType == "next") {
      setWidgAppSettingsAccordianContext(true);
      setExttrackingSettingsAccordianContext(false);
    }
    if (clickType == "back") {
      setExttrackingSettingsAccordianContext(false);

      if (
        productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0].feedbackAgentSettings &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
          FEEDBACK_TYPE_FEATURE_REQ
        )
      ) {
        setEmailSettingsAccordianContext(true);
      } else if (
        productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0].feedbackAgentSettings &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
          FEEDBACK_TYPE_BUGS
        )
      ) {
        setEmailSettingsAccordianContext(true);
      } else if (
        productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0].feedbackAgentSettings &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
          FEEDBACK_TYPE_FEEDBACK
        )
      ) {
        setEmailSettingsAccordianContext(true);
      } else {
        setGenSettingsAccordianContext(true);
      }
    }
  };
  const renderPreviuosBtnToolTip = () => {
    let tooltip: any = "";
    if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
        FEEDBACK_TYPE_FEATURE_REQ
      )
    ) {
      tooltip = "Go to Email Settings";
    } else if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
        FEEDBACK_TYPE_BUGS
      )
    ) {
      tooltip = "Go to Email Settings";
    } else if (
      productParams &&
      productParams.products &&
      productParams.products[0] &&
      productParams.products[0].feedbackAgentSettings &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes &&
      productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
        FEEDBACK_TYPE_FEEDBACK
      )
    ) {
      tooltip = "Go to Email Settings";
    } else {
      tooltip = "Go to General Settings";
    }
    return tooltip;
  };

  const handleCheckFieldError = () => {
    const fields = ["BUGS", "FEATURE_REQUEST", "FEEDBACK"];
    let hasError = false;

    for (const field of fields) {
      const fieldErrMsgObj = fieldErrMsg?.[field];
      const errMsgObj = errMsg?.[field];

      if (fieldErrMsgObj) {
        const { trackingKeyErr, trackingUserErr, trackingUrlErr } =
          fieldErrMsgObj;
        if (trackingKeyErr || trackingUserErr || trackingUrlErr) {
          hasError = true;
          break;
        }
      }

      if (errMsgObj) {
        const { extProjectTypeErr, extIssueTypeErr, extDefaultSevErr } =
          errMsgObj;
        if (extProjectTypeErr || extIssueTypeErr || extDefaultSevErr) {
          hasError = true;
          break;
        }
      }
    }

    return hasError;
  };
  let userEnabledFeatures: any = localStorage.getItem("userenabledFeatures");
  if (userEnabledFeatures) {
    userEnabledFeatures = JSON.parse(userEnabledFeatures);
  }
  return (
    <Box className="accordion-wrap">
      <JiraSetttingsHeader product={productParams?.products?.[0]} />
      {productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0].feedbackAgentSettings &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes &&
        productParams.products[0].feedbackAgentSettings.feedbackTypes.length >
          0 &&
        ((productParams.products[0].feedbackAgentSettings.feedbackTypes &&
          productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
            FEEDBACK_TYPE_BUGS
          )) ||
          (productParams.products[0].feedbackAgentSettings.feedbackTypes &&
            productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
              FEEDBACK_TYPE_FEATURE_REQ
            )) ||
          (productParams.products[0].feedbackAgentSettings.feedbackTypes &&
            productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
              FEEDBACK_TYPE_FEEDBACK
            ))) && (
          <>
            {userEnabledFeatures?.enableFeedback &&
            enableFeedback &&
            productParams &&
            productParams.products &&
            productParams.products[0] &&
            productParams.products[0].feedbackAgentSettings &&
            productParams.products[0].feedbackAgentSettings.feedbackTypes &&
            productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
              "FEEDBACK"
            ) ? (
              <Grid sx={{ mt: 2, mb: 2 }} item xs={12}>
                <Box
                  className={
                    isLoading &&
                    isLoading.length > 0 &&
                    isLoading === FEEDBACK_TYPE_FEEDBACK &&
                    !isFeedbackToolConnected
                      ? "feedback-track-wrap loader"
                      : "feedback-track-wrap"
                  }
                >
                  <Typography className="title">Feedback</Typography>
                  <>
                    {enableJira ? (
                      <>
                        <Grid item xs={12} sx={{ mt: 2 }}>
                          <FormControl className="custom-select" fullWidth>
                            <InputLabel>
                              The URl for your tracking/incident management
                              system
                              <div
                                style={{
                                  display: "inline-block",
                                  color: "red",
                                }}
                              >
                                *
                              </div>
                              {fieldErrMsg.FEEDBACK &&
                              fieldErrMsg.FEEDBACK.trackingUrlErr ? (
                                <div
                                  style={{
                                    display: "inline-block",
                                    color: "red",
                                  }}
                                >
                                  {fieldErrMsg.FEEDBACK.trackingUrlErr}
                                </div>
                              ) : (
                                <></>
                              )}
                            </InputLabel>
                            <OutlinedInput
                              type="text"
                              value={
                                productParams &&
                                productParams.products &&
                                productParams.products[0] &&
                                productParams.products[0].jiraSettings &&
                                productParams.products[0].jiraSettings
                                  .configs &&
                                productParams.products[0].jiraSettings.configs
                                  .FEEDBACK &&
                                productParams.products[0].jiraSettings.configs
                                  .FEEDBACK.url
                                  ? productParams.products[0].jiraSettings
                                      .configs.FEEDBACK.url
                                  : ""
                              }
                              disabled={isFeedbackToolConnected}
                              onChange={(event) =>
                                handleFieldChange(
                                  event,
                                  FEEDBACK_TYPE_FEEDBACK,
                                  "url"
                                )
                              }
                              id="urlTracking-select"
                              label="urlTracking"
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 2 }}>
                          <FormControl className="custom-select" fullWidth>
                            <InputLabel>
                              Provide auth user email for your tracking/incident
                              management system
                              <div
                                style={{
                                  display: "inline-block",
                                  color: "red",
                                }}
                              >
                                *
                              </div>
                              {fieldErrMsg.FEEDBACK &&
                              fieldErrMsg.FEEDBACK.trackingUserErr ? (
                                <div
                                  style={{
                                    display: "inline-block",
                                    color: "red",
                                  }}
                                >
                                  {fieldErrMsg.FEEDBACK.trackingUserErr}
                                </div>
                              ) : (
                                <></>
                              )}
                            </InputLabel>
                            <OutlinedInput
                              type="text"
                              value={
                                productParams &&
                                productParams.products &&
                                productParams.products[0] &&
                                productParams.products[0].jiraSettings &&
                                productParams.products[0].jiraSettings.configs
                                  .FEEDBACK.auth &&
                                productParams.products[0].jiraSettings.configs
                                  .FEEDBACK.auth["authUser"]
                                  ? productParams.products[0].jiraSettings
                                      .configs.FEEDBACK.auth["authUser"]
                                  : ""
                              }
                              onChange={(event) =>
                                handleAuthUserDetails(
                                  event,
                                  FEEDBACK_TYPE_FEEDBACK
                                )
                              }
                              disabled={isFeedbackToolConnected}
                              id="emailTracking-select"
                              label="emailTracking"
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sx={{ mt: 2 }}>
                          <HideOrShowText
                            placeHolder={
                              "Provide auth key for your tracking/incident management system"
                            }
                            value={
                              productParams &&
                              productParams.products &&
                              productParams.products[0] &&
                              productParams.products[0].jiraSettings &&
                              productParams.products[0].jiraSettings.configs[
                                FEEDBACK_TYPE_FEEDBACK
                              ].auth &&
                              productParams.products[0].jiraSettings.configs[
                                FEEDBACK_TYPE_FEEDBACK
                              ].auth["authKey"]
                                ? productParams.products[0].jiraSettings
                                    .configs[FEEDBACK_TYPE_FEEDBACK].auth[
                                    "authKey"
                                  ]
                                : ""
                            }
                            fieldKey={"jFeedbackAuthkey"}
                            onChange={(e) =>
                              handleAuthKeyDetails(e, FEEDBACK_TYPE_FEEDBACK)
                            }
                            disabled={isFeedbackToolConnected}
                            isMandatory={true}
                          />
                        </Grid>
                        {isFeedbackToolConnected ? (
                          <Grid item xs={12} sx={{ mt: 2 }}>
                            <Button
                              type="button"
                              variant="outlined"
                              sx={{
                                textTransform: "uppercase",
                                borderRadius: "24px",
                              }}
                              onClick={() =>
                                removeHandleConnection(FEEDBACK_TYPE_FEEDBACK)
                              }
                              // className="create-pro-btn"
                            >
                              Edit Connection details
                            </Button>
                          </Grid>
                        ) : (
                          <Grid item xs={12} sx={{ mt: 2 }}>
                            <Button
                              type="button"
                              variant="outlined"
                              sx={{
                                textTransform: "uppercase",
                                borderRadius: "24px",
                              }}
                              onClick={(event) =>
                                handleToolConnect(FEEDBACK_TYPE_FEEDBACK)
                              }
                              // className="create-pro-btn"
                            >
                              Connect
                            </Button>
                          </Grid>
                        )}
                        {isFeedbackToolConnected ? (
                          projectList &&
                          projectList[FEEDBACK_TYPE_FEEDBACK] &&
                          projectList[FEEDBACK_TYPE_FEEDBACK].length > 0 ? (
                            <>
                              <Grid item xs={12} sx={{ mt: 2 }}>
                                <FormControl
                                  className="custom-select"
                                  fullWidth
                                >
                                  <InputLabel>
                                    Provide subject for your jira ticket
                                  </InputLabel>
                                  <OutlinedInput
                                    type="text"
                                    value={
                                      productParams &&
                                      productParams.products &&
                                      productParams.products[0] &&
                                      productParams.products[0].jiraSettings &&
                                      productParams.products[0].jiraSettings
                                        .configs.FEEDBACK.subject
                                        ? productParams.products[0].jiraSettings
                                            .configs.FEEDBACK.subject
                                        : ""
                                    }
                                    onChange={(event) =>
                                      handleFieldChange(
                                        event,
                                        FEEDBACK_TYPE_FEEDBACK,
                                        "subject"
                                      )
                                    }
                                    id="subject-select"
                                    label="subject"
                                  />
                                </FormControl>
                              </Grid>
                              {isFeedbackToolConnected &&
                                projectList &&
                                projectList[FEEDBACK_TYPE_FEEDBACK] &&
                                projectList[FEEDBACK_TYPE_FEEDBACK].length >
                                  0 && (
                                  <Grid item xs={12} sx={{ mt: 2 }}>
                                    <FormControl
                                      className="custom-select"
                                      fullWidth
                                    >
                                      <InputLabel>
                                        Choose your project:
                                        <div
                                          style={{
                                            display: "inline-block",
                                            color: "red",
                                          }}
                                        >
                                          *
                                        </div>
                                        {errMsg &&
                                        errMsg.BUGS &&
                                        errMsg.FEEDBACK.extProjectTypeErr ? (
                                          <div
                                            style={{
                                              display: "inline-block",
                                              color: "red",
                                            }}
                                          >
                                            {errMsg &&
                                              errMsg.FEEDBACK.extProjectTypeErr}
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                      </InputLabel>
                                      <Select
                                        labelId="tracking-pro-select"
                                        id="tracking-pro-select"
                                        value={
                                          productParams &&
                                          productParams.products &&
                                          productParams.products[0] &&
                                          productParams.products[0]
                                            .jiraSettings &&
                                          productParams.products[0].jiraSettings
                                            .configs &&
                                          productParams.products[0].jiraSettings
                                            .configs[FEEDBACK_TYPE_FEEDBACK] &&
                                          productParams.products[0].jiraSettings
                                            .configs[FEEDBACK_TYPE_FEEDBACK]
                                            .project
                                            ? productParams.products[0]
                                                .jiraSettings.configs[
                                                FEEDBACK_TYPE_FEEDBACK
                                              ].project
                                            : ""
                                        }
                                        label="flow"
                                        onChange={(event) =>
                                          handleFieldChange(
                                            event,
                                            FEEDBACK_TYPE_FEEDBACK,
                                            "project"
                                          )
                                        }
                                      >
                                        {projectList &&
                                          projectList[FEEDBACK_TYPE_FEEDBACK] &&
                                          projectList[FEEDBACK_TYPE_FEEDBACK]
                                            .length > 0 &&
                                          projectList[
                                            FEEDBACK_TYPE_FEEDBACK
                                          ].map((menu: any) => {
                                            return (
                                              <MenuItem
                                                key={menu.key}
                                                value={menu.key}
                                              >
                                                {menu.name}
                                              </MenuItem>
                                            );
                                          })}
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                )}
                              {isFeedbackToolConnected &&
                                issueList &&
                                issueList[FEEDBACK_TYPE_FEEDBACK] &&
                                issueList[FEEDBACK_TYPE_FEEDBACK].length >
                                  0 && (
                                  <>
                                    <Grid item xs={12} sx={{ mt: 2 }}>
                                      <FormControl
                                        className="custom-select"
                                        fullWidth
                                      >
                                        <InputLabel>
                                          Choose your issue type:
                                          <div
                                            style={{
                                              display: "inline-block",
                                              color: "red",
                                            }}
                                          >
                                            *
                                          </div>
                                          {errMsg &&
                                          errMsg.FEEDBACK &&
                                          errMsg.FEEDBACK.extIssueTypeErr ? (
                                            <div
                                              style={{
                                                display: "inline-block",
                                                color: "red",
                                              }}
                                            >
                                              {errMsg &&
                                                errMsg.FEEDBACK.extIssueTypeErr}
                                            </div>
                                          ) : (
                                            <></>
                                          )}
                                        </InputLabel>
                                        <Select
                                          labelId="tracking-pro-select"
                                          id="tracking-pro-select"
                                          value={
                                            productParams &&
                                            productParams.products &&
                                            productParams.products[0] &&
                                            productParams.products[0]
                                              .jiraSettings &&
                                            productParams.products[0]
                                              .jiraSettings.configs &&
                                            productParams.products[0]
                                              .jiraSettings.configs[
                                              FEEDBACK_TYPE_FEEDBACK
                                            ] &&
                                            productParams.products[0]
                                              .jiraSettings.configs[
                                              FEEDBACK_TYPE_FEEDBACK
                                            ].issueType
                                              ? productParams.products[0]
                                                  .jiraSettings.configs[
                                                  FEEDBACK_TYPE_FEEDBACK
                                                ].issueType
                                              : ""
                                          }
                                          label="flow"
                                          onChange={(event) =>
                                            handleFieldChange(
                                              event,
                                              FEEDBACK_TYPE_FEEDBACK,
                                              "issueType"
                                            )
                                          }
                                        >
                                          {issueList &&
                                            issueList[FEEDBACK_TYPE_FEEDBACK] &&
                                            issueList[
                                              FEEDBACK_TYPE_FEEDBACK
                                            ].map((menu: any) => {
                                              return (
                                                <MenuItem
                                                  key={menu}
                                                  value={menu}
                                                >
                                                  {menu}
                                                </MenuItem>
                                              );
                                            })}
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                  </>
                                )}
                              {isFeedbackToolConnected &&
                                sevList[FEEDBACK_TYPE_FEEDBACK] &&
                                sevList[FEEDBACK_TYPE_FEEDBACK].length > 0 && (
                                  <>
                                    <Grid item xs={12} sx={{ mt: 2 }}>
                                      <FormControl
                                        className="custom-select"
                                        fullWidth
                                      >
                                        <InputLabel>
                                          Choose your default severity, if user
                                          doesn't select any:
                                          <div
                                            style={{
                                              display: "inline-block",
                                              color: "red",
                                            }}
                                          >
                                            *
                                          </div>
                                          {errMsg &&
                                          errMsg.FEEDBACK &&
                                          errMsg.FEEDBACK.extDefaultSevErr ? (
                                            <div
                                              style={{
                                                display: "inline-block",
                                                color: "red",
                                              }}
                                            >
                                              {errMsg.FEEDBACK.extDefaultSevErr}
                                            </div>
                                          ) : (
                                            <></>
                                          )}
                                        </InputLabel>
                                        <Select
                                          labelId="tracking-sev-select"
                                          id="tracking-sev-select"
                                          value={
                                            productParams &&
                                            productParams.products &&
                                            productParams.products[0] &&
                                            productParams.products[0]
                                              .jiraSettings &&
                                            productParams.products[0]
                                              .jiraSettings.configs &&
                                            productParams.products[0]
                                              .jiraSettings.configs[
                                              FEEDBACK_TYPE_FEEDBACK
                                            ] &&
                                            productParams.products[0]
                                              .jiraSettings.configs[
                                              FEEDBACK_TYPE_FEEDBACK
                                            ].defaultSeverity
                                              ? productParams.products[0]
                                                  .jiraSettings.configs[
                                                  FEEDBACK_TYPE_FEEDBACK
                                                ].defaultSeverity
                                              : ""
                                          }
                                          label="flow"
                                          onChange={(event) =>
                                            handleFieldChange(
                                              event,
                                              FEEDBACK_TYPE_FEEDBACK,
                                              "defaultSeverity"
                                            )
                                          }
                                        >
                                          {sevList[FEEDBACK_TYPE_FEEDBACK]
                                            .length > 0 &&
                                            sevList[FEEDBACK_TYPE_FEEDBACK].map(
                                              (menu: any) => {
                                                return (
                                                  <MenuItem
                                                    key={menu}
                                                    value={menu}
                                                  >
                                                    {menu}
                                                  </MenuItem>
                                                );
                                              }
                                            )}
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                  </>
                                )}
                            </>
                          ) : (
                            <>
                              <div className="tracking-sys-connection-warn">
                                <ErrorOutlineIcon
                                  style={{
                                    fontSize: "16px",
                                    marginRight: "3px",
                                    color: "red",
                                  }}
                                />
                                {` No project was found in Jira. Please check the connection details or create a project in Jira.`}
                              </div>
                            </>
                          )
                        ) : (
                          <></>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </>
                </Box>
              </Grid>
            ) : (
              <></>
            )}
            {((userEnabledFeatures?.enableBugReport && enableBugReport) ||
              (userEnabledFeatures?.enableChatbot && enableChatbot)) &&
            productParams &&
            productParams.products &&
            productParams.products[0] &&
            productParams.products[0].feedbackAgentSettings &&
            productParams.products[0].feedbackAgentSettings.feedbackTypes &&
            productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
              FEEDBACK_TYPE_BUGS
            ) ? (
              <Grid sx={{ mt: 2 }} item xs={12}>
                <Box
                  className={
                    isLoading &&
                    isLoading.length > 0 &&
                    isLoading === FEEDBACK_TYPE_BUGS &&
                    !isBugToolConnected
                      ? "bug-track-wrap loader"
                      : "bug-track-wrap"
                  }
                >
                  <Typography className="title">tickets</Typography>
                  <>
                    {enableJira ? (
                      <>
                        <Grid item xs={12} sx={{ mt: 2 }}>
                          <FormControl className="custom-select" fullWidth>
                            <InputLabel>
                              The URl for your tracking/incident management
                              system
                              <div
                                style={{
                                  display: "inline-block",
                                  color: "red",
                                }}
                              >
                                *
                              </div>
                              {fieldErrMsg.BUGS &&
                              fieldErrMsg.BUGS.trackingUrlErr ? (
                                <div
                                  style={{
                                    display: "inline-block",
                                    color: "red",
                                  }}
                                >
                                  {fieldErrMsg.BUGS.trackingUrlErr}
                                </div>
                              ) : (
                                <></>
                              )}
                            </InputLabel>
                            <OutlinedInput
                              type="text"
                              value={
                                productParams &&
                                productParams.products &&
                                productParams.products[0] &&
                                productParams.products[0].jiraSettings &&
                                productParams.products[0].jiraSettings
                                  .configs &&
                                productParams.products[0].jiraSettings.configs[
                                  FEEDBACK_TYPE_BUGS
                                ] &&
                                productParams.products[0].jiraSettings.configs[
                                  FEEDBACK_TYPE_BUGS
                                ].url
                                  ? productParams.products[0].jiraSettings
                                      .configs[FEEDBACK_TYPE_BUGS].url
                                  : ""
                              }
                              disabled={isBugToolConnected}
                              onChange={(event) =>
                                handleFieldChange(
                                  event,
                                  FEEDBACK_TYPE_BUGS,
                                  "url"
                                )
                              }
                              id="urlTracking-select"
                              label="urlTracking"
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 2 }}>
                          <FormControl className="custom-select" fullWidth>
                            <InputLabel>
                              Provide auth user email for your tracking/incident
                              management system
                              <div
                                style={{
                                  display: "inline-block",
                                  color: "red",
                                }}
                              >
                                *
                              </div>
                              {fieldErrMsg.BUGS &&
                              fieldErrMsg.BUGS.trackingUserErr ? (
                                <div
                                  style={{
                                    display: "inline-block",
                                    color: "red",
                                  }}
                                >
                                  {fieldErrMsg.BUGS.trackingUserErr}
                                </div>
                              ) : (
                                <></>
                              )}
                            </InputLabel>
                            <OutlinedInput
                              type="text"
                              value={
                                productParams &&
                                productParams.products &&
                                productParams.products[0] &&
                                productParams.products[0].jiraSettings &&
                                productParams.products[0].jiraSettings.configs[
                                  FEEDBACK_TYPE_BUGS
                                ].auth &&
                                productParams.products[0].jiraSettings.configs[
                                  FEEDBACK_TYPE_BUGS
                                ].auth["authUser"]
                                  ? productParams.products[0].jiraSettings
                                      .configs[FEEDBACK_TYPE_BUGS].auth[
                                      "authUser"
                                    ]
                                  : ""
                              }
                              onChange={(event) =>
                                handleAuthUserDetails(event, FEEDBACK_TYPE_BUGS)
                              }
                              disabled={isBugToolConnected}
                              id="emailTracking-select"
                              label="emailTracking"
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 2 }}>
                          <HideOrShowText
                            placeHolder={
                              "Provide auth key for your tracking/incident management system"
                            }
                            value={
                              productParams &&
                              productParams.products &&
                              productParams.products[0] &&
                              productParams.products[0].jiraSettings &&
                              productParams.products[0].jiraSettings.configs[
                                FEEDBACK_TYPE_BUGS
                              ].auth &&
                              productParams.products[0].jiraSettings.configs[
                                FEEDBACK_TYPE_BUGS
                              ].auth["authKey"]
                                ? productParams.products[0].jiraSettings
                                    .configs[FEEDBACK_TYPE_BUGS].auth["authKey"]
                                : ""
                            }
                            fieldKey={"jBugAuthkey"}
                            onChange={(e) =>
                              handleAuthKeyDetails(e, FEEDBACK_TYPE_BUGS)
                            }
                            disabled={isBugToolConnected}
                            isMandatory={true}
                          />
                        </Grid>
                        {isBugToolConnected ? (
                          <Grid item xs={12} sx={{ mt: 2 }}>
                            <Button
                              type="button"
                              variant="outlined"
                              sx={{
                                textTransform: "uppercase",
                                borderRadius: "24px",
                              }}
                              onClick={() =>
                                removeHandleConnection(FEEDBACK_TYPE_BUGS)
                              }
                              // className="create-pro-btn"
                            >
                              Edit Connection Details
                            </Button>
                          </Grid>
                        ) : (
                          <Grid item xs={12} sx={{ mt: 2 }}>
                            <Button
                              type="button"
                              variant="outlined"
                              sx={{
                                textTransform: "uppercase",
                                borderRadius: "24px",
                              }}
                              onClick={(event) =>
                                handleToolConnect(FEEDBACK_TYPE_BUGS)
                              }
                              // className="create-pro-btn"
                            >
                              Connect
                            </Button>
                          </Grid>
                        )}
                        {isBugToolConnected ? (
                          projectList &&
                          projectList[FEEDBACK_TYPE_BUGS] &&
                          projectList[FEEDBACK_TYPE_BUGS].length > 0 ? (
                            <>
                              <Grid item xs={12} sx={{ mt: 2 }}>
                                <FormControl
                                  className="custom-select"
                                  fullWidth
                                >
                                  <InputLabel>
                                    Provide subject for your jira ticket
                                  </InputLabel>
                                  <OutlinedInput
                                    type="text"
                                    value={
                                      productParams &&
                                      productParams.products &&
                                      productParams.products[0] &&
                                      productParams.products[0].jiraSettings &&
                                      productParams.products[0].jiraSettings
                                        .configs.BUGS.subject
                                        ? productParams.products[0].jiraSettings
                                            .configs.BUGS.subject
                                        : ""
                                    }
                                    onChange={(event) =>
                                      handleFieldChange(
                                        event,
                                        FEEDBACK_TYPE_BUGS,
                                        "subject"
                                      )
                                    }
                                    id="subject-select"
                                    label="subject"
                                  />
                                </FormControl>
                              </Grid>
                              {isBugToolConnected &&
                                projectList &&
                                projectList[FEEDBACK_TYPE_BUGS] &&
                                projectList[FEEDBACK_TYPE_BUGS].length > 0 && (
                                  <Grid item xs={12} sx={{ mt: 2 }}>
                                    <FormControl
                                      className="custom-select"
                                      fullWidth
                                    >
                                      <InputLabel>
                                        Choose your project:
                                        <div
                                          style={{
                                            display: "inline-block",
                                            color: "red",
                                          }}
                                        >
                                          *
                                        </div>
                                        {errMsg &&
                                        errMsg.BUGS &&
                                        errMsg.BUGS.extProjectTypeErr ? (
                                          <div
                                            style={{
                                              display: "inline-block",
                                              color: "red",
                                            }}
                                          >
                                            {errMsg.BUGS.extProjectTypeErr}
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                      </InputLabel>
                                      <Select
                                        labelId="tracking-pro-select"
                                        id="tracking-pro-select"
                                        value={
                                          productParams &&
                                          productParams.products &&
                                          productParams.products[0] &&
                                          productParams.products[0]
                                            .jiraSettings &&
                                          productParams.products[0].jiraSettings
                                            .configs &&
                                          productParams.products[0].jiraSettings
                                            .configs[FEEDBACK_TYPE_BUGS] &&
                                          productParams.products[0].jiraSettings
                                            .configs[FEEDBACK_TYPE_BUGS].project
                                            ? productParams.products[0]
                                                .jiraSettings.configs[
                                                FEEDBACK_TYPE_BUGS
                                              ].project
                                            : ""
                                        }
                                        label="flow"
                                        onChange={(event) =>
                                          handleFieldChange(
                                            event,
                                            FEEDBACK_TYPE_BUGS,
                                            "project"
                                          )
                                        }
                                      >
                                        {projectList &&
                                          projectList[FEEDBACK_TYPE_BUGS] &&
                                          projectList[FEEDBACK_TYPE_BUGS]
                                            .length > 0 &&
                                          projectList[FEEDBACK_TYPE_BUGS].map(
                                            (menu: any) => {
                                              return (
                                                <MenuItem
                                                  key={menu.key}
                                                  value={menu.key}
                                                >
                                                  {menu.name}
                                                </MenuItem>
                                              );
                                            }
                                          )}
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                )}
                              {isBugToolConnected &&
                                issueList &&
                                issueList[FEEDBACK_TYPE_BUGS] &&
                                issueList[FEEDBACK_TYPE_BUGS].length > 0 && (
                                  <>
                                    <Grid item xs={12} sx={{ mt: 2 }}>
                                      <FormControl
                                        className="custom-select"
                                        fullWidth
                                      >
                                        <InputLabel>
                                          Choose your issue type:
                                          <div
                                            style={{
                                              display: "inline-block",
                                              color: "red",
                                            }}
                                          >
                                            *
                                          </div>
                                          {errMsg &&
                                          errMsg.BUGS &&
                                          errMsg.BUGS.extIssueTypeErr ? (
                                            <div
                                              style={{
                                                display: "inline-block",
                                                color: "red",
                                              }}
                                            >
                                              {errMsg.BUGS.extIssueTypeErr}
                                            </div>
                                          ) : (
                                            <></>
                                          )}
                                        </InputLabel>
                                        <Select
                                          labelId="tracking-pro-select"
                                          id="tracking-pro-select"
                                          value={
                                            productParams &&
                                            productParams.products &&
                                            productParams.products[0] &&
                                            productParams.products[0]
                                              .jiraSettings &&
                                            productParams.products[0]
                                              .jiraSettings.configs &&
                                            productParams.products[0]
                                              .jiraSettings.configs[
                                              FEEDBACK_TYPE_BUGS
                                            ] &&
                                            productParams.products[0]
                                              .jiraSettings.configs[
                                              FEEDBACK_TYPE_BUGS
                                            ].issueType
                                              ? productParams.products[0]
                                                  .jiraSettings.configs[
                                                  FEEDBACK_TYPE_BUGS
                                                ].issueType
                                              : ""
                                          }
                                          label="flow"
                                          onChange={(event) =>
                                            handleFieldChange(
                                              event,
                                              FEEDBACK_TYPE_BUGS,
                                              "issueType"
                                            )
                                          }
                                        >
                                          {issueList[FEEDBACK_TYPE_BUGS] &&
                                            issueList[FEEDBACK_TYPE_BUGS]
                                              .length > 0 &&
                                            issueList[FEEDBACK_TYPE_BUGS].map(
                                              (menu: any) => {
                                                return (
                                                  <MenuItem
                                                    key={menu}
                                                    value={menu}
                                                  >
                                                    {menu}
                                                  </MenuItem>
                                                );
                                              }
                                            )}
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                  </>
                                )}
                              {isBugToolConnected &&
                                sevList[FEEDBACK_TYPE_BUGS] &&
                                sevList[FEEDBACK_TYPE_BUGS].length > 0 && (
                                  <>
                                    <Grid item xs={12} sx={{ mt: 2 }}>
                                      <FormControl
                                        className="custom-select"
                                        fullWidth
                                      >
                                        <InputLabel>
                                          Choose your default severity, if user
                                          doesn't select any:
                                          <div
                                            style={{
                                              display: "inline-block",
                                              color: "red",
                                            }}
                                          >
                                            *
                                          </div>
                                          {errMsg &&
                                          errMsg.BUGS &&
                                          errMsg.BUGS.extDefaultSevErr ? (
                                            <div
                                              style={{
                                                display: "inline-block",
                                                color: "red",
                                              }}
                                            >
                                              {errMsg.BUGS.extDefaultSevErr}
                                            </div>
                                          ) : (
                                            <></>
                                          )}
                                        </InputLabel>
                                        <Select
                                          labelId="tracking-sev-select"
                                          id="tracking-sev-select"
                                          value={
                                            productParams &&
                                            productParams.products &&
                                            productParams.products[0] &&
                                            productParams.products[0]
                                              .jiraSettings &&
                                            productParams.products[0]
                                              .jiraSettings.configs &&
                                            productParams.products[0]
                                              .jiraSettings.configs[
                                              FEEDBACK_TYPE_BUGS
                                            ] &&
                                            productParams.products[0]
                                              .jiraSettings.configs[
                                              FEEDBACK_TYPE_BUGS
                                            ].defaultSeverity
                                              ? productParams.products[0]
                                                  .jiraSettings.configs[
                                                  FEEDBACK_TYPE_BUGS
                                                ].defaultSeverity
                                              : ""
                                          }
                                          label="flow"
                                          onChange={(event) =>
                                            handleFieldChange(
                                              event,
                                              FEEDBACK_TYPE_BUGS,
                                              "defaultSeverity"
                                            )
                                          }
                                        >
                                          {sevList[FEEDBACK_TYPE_BUGS].length >
                                            0 &&
                                            sevList[FEEDBACK_TYPE_BUGS].map(
                                              (menu: any) => {
                                                return (
                                                  <MenuItem
                                                    key={menu}
                                                    value={menu}
                                                  >
                                                    {menu}
                                                  </MenuItem>
                                                );
                                              }
                                            )}
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                    <div className="jira-severity-note">
                                      <ErrorOutlineIcon
                                        style={{
                                          fontSize: "16px",
                                          marginRight: "3px",
                                        }}
                                      />
                                      {`Note : `}
                                      {` Severity options in Bug Settings will be overriden by Jira priority options`}
                                    </div>
                                  </>
                                )}
                            </>
                          ) : (
                            <>
                              <div className="tracking-sys-connection-warn">
                                <ErrorOutlineIcon
                                  style={{
                                    fontSize: "16px",
                                    marginRight: "3px",
                                    color: "red",
                                  }}
                                />
                                {` No project was found in Jira. Please check the connection details or create a project in Jira.`}
                              </div>
                            </>
                          )
                        ) : (
                          <></>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </>
                </Box>
              </Grid>
            ) : (
              <></>
            )}
            {userEnabledFeatures?.enableFeatureRequest &&
            enableFeatureRequest &&
            productParams &&
            productParams.products &&
            productParams.products[0] &&
            productParams.products[0].feedbackAgentSettings &&
            productParams.products[0].feedbackAgentSettings.feedbackTypes &&
            productParams.products[0].feedbackAgentSettings.feedbackTypes.includes(
              "FEATURE_REQUEST"
            ) ? (
              <Grid sx={{ mt: 2 }} item xs={12}>
                <Box
                  className={
                    isLoading &&
                    isLoading.length > 0 &&
                    isLoading === FEEDBACK_TYPE_FEATURE_REQ &&
                    !isFeatureToolConnected
                      ? "feature-track-wrap loader"
                      : "feature-track-wrap"
                  }
                >
                  <Typography className="title">feature request</Typography>
                  <>
                    {enableJira ? (
                      <>
                        <Grid item xs={12} sx={{ mt: 2 }}>
                          <FormControl className="custom-select" fullWidth>
                            <InputLabel>
                              The URl for your tracking/incident management
                              system
                              <div
                                style={{
                                  display: "inline-block",
                                  color: "red",
                                }}
                              >
                                *
                              </div>
                              {fieldErrMsg.FEATURE_REQUEST &&
                              fieldErrMsg.FEATURE_REQUEST.trackingUrlErr ? (
                                <div
                                  style={{
                                    display: "inline-block",
                                    color: "red",
                                  }}
                                >
                                  {fieldErrMsg.FEATURE_REQUEST.trackingUrlErr}
                                </div>
                              ) : (
                                <></>
                              )}
                            </InputLabel>
                            <OutlinedInput
                              type="text"
                              value={
                                productParams &&
                                productParams.products &&
                                productParams.products[0] &&
                                productParams.products[0].jiraSettings &&
                                productParams.products[0].jiraSettings
                                  .configs &&
                                productParams.products[0].jiraSettings.configs
                                  .FEATURE_REQUEST &&
                                productParams.products[0].jiraSettings.configs
                                  .FEATURE_REQUEST.url
                                  ? productParams.products[0].jiraSettings
                                      .configs.FEATURE_REQUEST.url
                                  : ""
                              }
                              disabled={isFeatureToolConnected}
                              onChange={(event) =>
                                handleFieldChange(
                                  event,
                                  FEEDBACK_TYPE_FEATURE_REQ,
                                  "url"
                                )
                              }
                              id="urlTracking-select"
                              label="urlTracking"
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 2 }}>
                          <FormControl className="custom-select" fullWidth>
                            <InputLabel>
                              Provide auth user email for your tracking/incident
                              management system
                              <div
                                style={{
                                  display: "inline-block",
                                  color: "red",
                                }}
                              >
                                *
                              </div>
                              {fieldErrMsg.FEATURE_REQUEST &&
                              fieldErrMsg.FEATURE_REQUEST.trackingUserErr ? (
                                <div
                                  style={{
                                    display: "inline-block",
                                    color: "red",
                                  }}
                                >
                                  {fieldErrMsg.FEATURE_REQUEST.trackingUserErr}
                                </div>
                              ) : (
                                <></>
                              )}
                            </InputLabel>
                            <OutlinedInput
                              type="text"
                              value={
                                productParams &&
                                productParams.products &&
                                productParams.products[0] &&
                                productParams.products[0].jiraSettings &&
                                productParams.products[0].jiraSettings.configs
                                  .FEATURE_REQUEST.auth &&
                                productParams.products[0].jiraSettings.configs
                                  .FEATURE_REQUEST.auth["authUser"]
                                  ? productParams.products[0].jiraSettings
                                      .configs.FEATURE_REQUEST.auth["authUser"]
                                  : ""
                              }
                              onChange={(event) =>
                                handleAuthUserDetails(
                                  event,
                                  FEEDBACK_TYPE_FEATURE_REQ
                                )
                              }
                              disabled={isFeatureToolConnected}
                              id="emailTracking-select"
                              label="emailTracking"
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sx={{ mt: 2 }}>
                          <HideOrShowText
                            placeHolder={
                              "Provide auth key for your tracking/incident management system"
                            }
                            value={
                              productParams &&
                              productParams.products &&
                              productParams.products[0] &&
                              productParams.products[0].jiraSettings &&
                              productParams.products[0].jiraSettings.configs[
                                FEEDBACK_TYPE_FEATURE_REQ
                              ].auth &&
                              productParams.products[0].jiraSettings.configs[
                                FEEDBACK_TYPE_FEATURE_REQ
                              ].auth["authKey"]
                                ? productParams.products[0].jiraSettings
                                    .configs[FEEDBACK_TYPE_FEATURE_REQ].auth[
                                    "authKey"
                                  ]
                                : ""
                            }
                            fieldKey={"jFeatureAuthkey"}
                            onChange={(e) =>
                              handleAuthKeyDetails(e, FEEDBACK_TYPE_FEATURE_REQ)
                            }
                            disabled={isFeatureToolConnected}
                            isMandatory={true}
                          />
                        </Grid>
                        {isFeatureToolConnected ? (
                          <Grid item xs={12} sx={{ mt: 2 }}>
                            <Button
                              type="button"
                              variant="outlined"
                              sx={{
                                textTransform: "uppercase",
                                borderRadius: "24px",
                              }}
                              onClick={() =>
                                removeHandleConnection(
                                  FEEDBACK_TYPE_FEATURE_REQ
                                )
                              }
                              // className="create-pro-btn"
                            >
                              Edit Connection details
                            </Button>
                          </Grid>
                        ) : (
                          <Grid item xs={12} sx={{ mt: 2 }}>
                            <Button
                              type="button"
                              variant="outlined"
                              sx={{
                                textTransform: "uppercase",
                                borderRadius: "24px",
                              }}
                              onClick={(event) =>
                                handleToolConnect(FEEDBACK_TYPE_FEATURE_REQ)
                              }
                              // className="create-pro-btn"
                            >
                              Connect
                            </Button>
                          </Grid>
                        )}
                        {isFeatureToolConnected ? (
                          projectList &&
                          projectList[FEEDBACK_TYPE_FEATURE_REQ] &&
                          projectList[FEEDBACK_TYPE_FEATURE_REQ].length > 0 ? (
                            <>
                              <Grid item xs={12} sx={{ mt: 2 }}>
                                <FormControl
                                  className="custom-select"
                                  fullWidth
                                >
                                  <InputLabel>
                                    Provide subject for your jira ticket
                                  </InputLabel>
                                  <OutlinedInput
                                    type="text"
                                    value={
                                      productParams &&
                                      productParams.products &&
                                      productParams.products[0] &&
                                      productParams.products[0].jiraSettings &&
                                      productParams.products[0].jiraSettings
                                        .configs.FEATURE_REQUEST.subject
                                        ? productParams.products[0].jiraSettings
                                            .configs.FEATURE_REQUEST.subject
                                        : ""
                                    }
                                    onChange={(event) =>
                                      handleFieldChange(
                                        event,
                                        FEEDBACK_TYPE_FEATURE_REQ,
                                        "subject"
                                      )
                                    }
                                    id="subject-select"
                                    label="subject"
                                  />
                                </FormControl>
                              </Grid>
                              {isFeatureToolConnected &&
                                projectList &&
                                projectList[FEEDBACK_TYPE_FEATURE_REQ] &&
                                projectList[FEEDBACK_TYPE_FEATURE_REQ].length >
                                  0 && (
                                  <Grid item xs={12} sx={{ mt: 2 }}>
                                    <FormControl
                                      className="custom-select"
                                      fullWidth
                                    >
                                      <InputLabel>
                                        Choose your project:
                                        <div
                                          style={{
                                            display: "inline-block",
                                            color: "red",
                                          }}
                                        >
                                          *
                                        </div>
                                        {errMsg &&
                                        errMsg.FEATURE_REQUEST &&
                                        errMsg.FEATURE_REQUEST
                                          .extProjectTypeErr ? (
                                          <div
                                            style={{
                                              display: "inline-block",
                                              color: "red",
                                            }}
                                          >
                                            {
                                              errMsg.FEATURE_REQUEST
                                                .extProjectTypeErr
                                            }
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                      </InputLabel>
                                      <Select
                                        labelId="tracking-pro-select"
                                        id="tracking-pro-select"
                                        value={
                                          productParams &&
                                          productParams.products &&
                                          productParams.products[0] &&
                                          productParams.products[0]
                                            .jiraSettings &&
                                          productParams.products[0].jiraSettings
                                            .configs &&
                                          productParams.products[0].jiraSettings
                                            .configs[
                                            FEEDBACK_TYPE_FEATURE_REQ
                                          ] &&
                                          productParams.products[0].jiraSettings
                                            .configs[FEEDBACK_TYPE_FEATURE_REQ]
                                            .project
                                            ? productParams.products[0]
                                                .jiraSettings.configs[
                                                FEEDBACK_TYPE_FEATURE_REQ
                                              ].project
                                            : ""
                                        }
                                        label="flow"
                                        onChange={(event) =>
                                          handleFieldChange(
                                            event,
                                            FEEDBACK_TYPE_FEATURE_REQ,
                                            "project"
                                          )
                                        }
                                      >
                                        {projectList &&
                                          projectList[
                                            FEEDBACK_TYPE_FEATURE_REQ
                                          ] &&
                                          projectList[FEEDBACK_TYPE_FEATURE_REQ]
                                            .length > 0 &&
                                          projectList[
                                            FEEDBACK_TYPE_FEATURE_REQ
                                          ].map((menu: any) => {
                                            return (
                                              <MenuItem
                                                key={menu.key}
                                                value={menu.key}
                                              >
                                                {menu.name}
                                              </MenuItem>
                                            );
                                          })}
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                )}
                              {isFeatureToolConnected &&
                                issueList &&
                                issueList[FEEDBACK_TYPE_FEATURE_REQ] &&
                                issueList[FEEDBACK_TYPE_FEATURE_REQ].length >
                                  0 && (
                                  <>
                                    <Grid item xs={12} sx={{ mt: 2 }}>
                                      <FormControl
                                        className="custom-select"
                                        fullWidth
                                      >
                                        <InputLabel>
                                          Choose your issue type:
                                          <div
                                            style={{
                                              display: "inline-block",
                                              color: "red",
                                            }}
                                          >
                                            *
                                          </div>
                                          {errMsg &&
                                          errMsg.FEATURE_REQUEST &&
                                          errMsg.FEATURE_REQUEST
                                            .extIssueTypeErr ? (
                                            <div
                                              style={{
                                                display: "inline-block",
                                                color: "red",
                                              }}
                                            >
                                              {
                                                errMsg.FEATURE_REQUEST
                                                  .extIssueTypeErr
                                              }
                                            </div>
                                          ) : (
                                            <></>
                                          )}
                                        </InputLabel>
                                        <Select
                                          labelId="tracking-pro-select"
                                          id="tracking-pro-select"
                                          value={
                                            productParams &&
                                            productParams.products &&
                                            productParams.products[0] &&
                                            productParams.products[0]
                                              .jiraSettings &&
                                            productParams.products[0]
                                              .jiraSettings.configs &&
                                            productParams.products[0]
                                              .jiraSettings.configs[
                                              FEEDBACK_TYPE_FEATURE_REQ
                                            ] &&
                                            productParams.products[0]
                                              .jiraSettings.configs[
                                              FEEDBACK_TYPE_FEATURE_REQ
                                            ].issueType
                                              ? productParams.products[0]
                                                  .jiraSettings.configs[
                                                  FEEDBACK_TYPE_FEATURE_REQ
                                                ].issueType
                                              : ""
                                          }
                                          label="flow"
                                          onChange={(event) =>
                                            handleFieldChange(
                                              event,
                                              FEEDBACK_TYPE_FEATURE_REQ,
                                              "issueType"
                                            )
                                          }
                                        >
                                          {issueList &&
                                            issueList[
                                              FEEDBACK_TYPE_FEATURE_REQ
                                            ] &&
                                            issueList[
                                              FEEDBACK_TYPE_FEATURE_REQ
                                            ].map((menu: any) => {
                                              return (
                                                <MenuItem
                                                  key={menu}
                                                  value={menu}
                                                >
                                                  {menu}
                                                </MenuItem>
                                              );
                                            })}
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                  </>
                                )}
                              {isFeatureToolConnected &&
                                sevList[FEEDBACK_TYPE_FEATURE_REQ] &&
                                sevList[FEEDBACK_TYPE_FEATURE_REQ].length >
                                  0 && (
                                  <>
                                    <Grid item xs={12} sx={{ mt: 2 }}>
                                      <FormControl
                                        className="custom-select"
                                        fullWidth
                                      >
                                        <InputLabel>
                                          Choose your default severity, if user
                                          doesn't select any:
                                          <div
                                            style={{
                                              display: "inline-block",
                                              color: "red",
                                            }}
                                          >
                                            *
                                          </div>
                                          {errMsg &&
                                          errMsg.FEATURE_REQUEST &&
                                          errMsg.FEATURE_REQUEST
                                            .extDefaultSevErr ? (
                                            <div
                                              style={{
                                                display: "inline-block",
                                                color: "red",
                                              }}
                                            >
                                              {
                                                errMsg.FEATURE_REQUEST
                                                  .extDefaultSevErr
                                              }
                                            </div>
                                          ) : (
                                            <></>
                                          )}
                                        </InputLabel>
                                        <Select
                                          labelId="tracking-sev-select"
                                          id="tracking-sev-select"
                                          value={
                                            productParams &&
                                            productParams.products &&
                                            productParams.products[0] &&
                                            productParams.products[0]
                                              .jiraSettings &&
                                            productParams.products[0]
                                              .jiraSettings.configs &&
                                            productParams.products[0]
                                              .jiraSettings.configs[
                                              FEEDBACK_TYPE_FEATURE_REQ
                                            ] &&
                                            productParams.products[0]
                                              .jiraSettings.configs[
                                              FEEDBACK_TYPE_FEATURE_REQ
                                            ].defaultSeverity
                                              ? productParams.products[0]
                                                  .jiraSettings.configs[
                                                  FEEDBACK_TYPE_FEATURE_REQ
                                                ].defaultSeverity
                                              : ""
                                          }
                                          label="flow"
                                          onChange={(event) =>
                                            handleFieldChange(
                                              event,
                                              FEEDBACK_TYPE_FEATURE_REQ,
                                              "defaultSeverity"
                                            )
                                          }
                                        >
                                          {sevList[FEEDBACK_TYPE_FEATURE_REQ]
                                            .length > 0 &&
                                            sevList[
                                              FEEDBACK_TYPE_FEATURE_REQ
                                            ].map((menu: any) => {
                                              return (
                                                <MenuItem
                                                  key={menu}
                                                  value={menu}
                                                >
                                                  {menu}
                                                </MenuItem>
                                              );
                                            })}
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                  </>
                                )}
                            </>
                          ) : (
                            <>
                              <div className="tracking-sys-connection-warn">
                                <ErrorOutlineIcon
                                  style={{
                                    fontSize: "16px",
                                    marginRight: "3px",
                                    color: "red",
                                  }}
                                />
                                {` No project was found in Jira. Please check the connection details or create a project in Jira.`}
                              </div>
                            </>
                          )
                        ) : (
                          <></>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </>
                </Box>
              </Grid>
            ) : (
              <></>
            )}
          </>
        )}
    </Box>
  );
};

export default withSnackbar(TrackingSystemSettings);
